import { jsx as c, jsxs as w, Fragment as V } from "react/jsx-runtime";
import { DismissableLayer as G } from "@radix-ui/react-dismissable-layer";
import { useControllableState as M } from "@radix-ui/react-use-controllable-state";
import * as Y from "@radix-ui/react-visually-hidden";
import { Button as v } from "@telegraph/button";
import { useComposedRefs as K } from "@telegraph/compose-refs";
import { RefToTgphRef as $ } from "@telegraph/helpers";
import { Lucide as R, Icon as F } from "@telegraph/icon";
import { Input as X } from "@telegraph/input";
import { Stack as I, Box as A } from "@telegraph/layout";
import { Menu as D } from "@telegraph/menu";
import { Tag as O } from "@telegraph/tag";
import { Tooltip as q } from "@telegraph/tooltip";
import { Text as L } from "@telegraph/typography";
import i from "react";
const z = {
  0: "5",
  1: "6",
  2: "8",
  3: "10"
}, C = (t) => Array.isArray(t), k = (t) => typeof t == "object" && !Array.isArray(t) || !t, N = ["ArrowDown", "PageUp", "Home"], U = ["ArrowUp", "PageDown", "End"], j = ["Enter", " "], m = i.createContext({
  value: void 0,
  onValueChange: () => {
  },
  contentId: "",
  triggerId: "",
  open: !1,
  setOpen: () => {
  },
  onOpenToggle: () => {
  },
  clearable: !1,
  disabled: !1
}), J = ({
  modal: t = !0,
  closeOnSelect: l = !0,
  clearable: e = !1,
  disabled: u = !1,
  open: s,
  onOpenChange: a,
  defaultOpen: o,
  value: n,
  onValueChange: r,
  errored: g,
  placeholder: h,
  layout: b,
  ...p
}) => {
  const d = i.useId(), x = i.useId(), y = i.useRef(null), f = i.useRef(null), S = i.useRef(null), [T, P] = i.useState(""), [E = !1, Q] = M({
    prop: s,
    defaultProp: o,
    onChange: a
  }), H = i.useCallback(() => {
    Q((_) => !_);
  }, [Q]);
  return i.useEffect(() => {
    E || P("");
  }, [E]), /* @__PURE__ */ c(
    m.Provider,
    {
      value: {
        contentId: d,
        triggerId: x,
        value: n,
        // Need to cast this to avoid type errors
        // because the type of onValueChange is not
        // consistent with the value type
        onValueChange: r,
        placeholder: h,
        open: E,
        setOpen: Q,
        onOpenToggle: H,
        closeOnSelect: l,
        clearable: e,
        disabled: u,
        searchQuery: T,
        setSearchQuery: P,
        triggerRef: y,
        searchRef: f,
        contentRef: S,
        errored: g,
        layout: b
      },
      children: /* @__PURE__ */ c(
        D.Root,
        {
          open: E,
          onOpenChange: Q,
          modal: t,
          ...p
        }
      )
    }
  );
}, W = ({ label: t, value: l, ...e }) => {
  const u = i.useContext(m);
  return /* @__PURE__ */ w(O.Root, { size: "1", layout: "position", ...e, children: [
    /* @__PURE__ */ c(O.Text, { children: t || l }),
    /* @__PURE__ */ c(
      O.Button,
      {
        icon: { icon: R.X, alt: `Remove ${l}` },
        onClick: (s) => {
          if (!u.onValueChange) return;
          const a = u.onValueChange, n = u.value.filter((r) => (r == null ? void 0 : r.value) !== l);
          a == null || a(n), s.stopPropagation(), s.preventDefault();
        }
      }
    )
  ] });
}, Z = () => {
  var l, e;
  const t = i.useContext(m);
  if (t.value && C(t.value)) {
    const u = t.layout || "truncate", s = t.value.length - 2, a = s.toString().split("");
    return t.value.length === 0 ? /* @__PURE__ */ c(v.Text, { color: "gray", children: t.placeholder }) : /* @__PURE__ */ w(
      I,
      {
        gap: "1",
        w: "full",
        wrap: u === "wrap" ? "wrap" : "nowrap",
        align: "center",
        style: {
          position: "relative",
          flexGrow: 1
        },
        children: [
          t.value.map((o, n) => {
            if (o != null && o.value && (u === "truncate" && n <= 1 || u === "wrap"))
              return /* @__PURE__ */ c($, { children: /* @__PURE__ */ c(W, { ...o }) }, o.value);
          }),
          u === "truncate" && t.value.length > 2 && /* @__PURE__ */ c(
            I,
            {
              h: "full",
              pr: "1",
              pl: "8",
              align: "center",
              "aria-label": `${s} more selected`,
              position: "absolute",
              right: "0",
              style: {
                backgroundImage: "linear-gradient(to left, var(--tgph-surface-1) 0 60%, transparent 90% 100%)"
              },
              children: /* @__PURE__ */ w(L, { as: "span", size: "1", style: { whiteSpace: "nowrap" }, children: [
                "+",
                a.map((o) => /* @__PURE__ */ c(A, { as: "span", w: "2", display: "inline-block", children: o }, o)),
                " ",
                "more"
              ] })
            }
          )
        ]
      }
    );
  }
  return /* @__PURE__ */ c(v.Text, { color: t.value ? "default" : "gray", children: ((l = t == null ? void 0 : t.value) == null ? void 0 : l.label) || ((e = t == null ? void 0 : t.value) == null ? void 0 : e.value) || t.placeholder });
}, ee = ({ size: t = "2", ...l }) => {
  const e = i.useContext(m), u = i.useCallback(() => {
    var o, n, r;
    return e.value ? k(e.value) ? ((o = e.value) == null ? void 0 : o.label) || ((n = e.value) == null ? void 0 : n.value) || e.placeholder : ((r = e.value) == null ? void 0 : r.map((g) => g == null ? void 0 : g.label).join(", ")) || e.placeholder : e.placeholder;
  }, [e.value, e.placeholder]), s = i.useMemo(() => {
    var o;
    if (C(e.value))
      return e.clearable && ((o = e.value) == null ? void 0 : o.length) > 0;
    if (k(e.value))
      return e.clearable && e.value;
  }, [e.clearable, e.value]), a = () => {
    var o, n;
    if (C(e.value)) {
      const r = e.onValueChange;
      r == null || r([]);
    }
    if (k(e.value)) {
      const r = e.onValueChange;
      r == null || r(void 0);
    }
    (n = (o = e.triggerRef) == null ? void 0 : o.current) == null || n.focus();
  };
  return /* @__PURE__ */ c(
    D.Trigger,
    {
      ...l,
      asChild: !0,
      onClick: (o) => {
        var n, r;
        o.preventDefault(), e.onOpenToggle(), (r = (n = e.triggerRef) == null ? void 0 : n.current) == null || r.focus();
      },
      onKeyDown: (o) => {
        if (o.key === "Tab") {
          o.stopPropagation();
          return;
        }
        if (j.includes(o.key)) {
          o.preventDefault();
          return;
        }
        if (o.key === "ArrowDown") {
          o.stopPropagation(), o.preventDefault(), e.onOpenToggle();
          return;
        }
      },
      tgphRef: e.triggerRef,
      children: /* @__PURE__ */ w(
        v.Root,
        {
          id: e.triggerId,
          type: "button",
          bg: "surface-1",
          variant: "outline",
          align: "center",
          minH: z[t],
          h: "full",
          w: "full",
          py: "1",
          size: t,
          color: e.errored ? "red" : "gray",
          justify: "space-between",
          role: "combobox",
          "aria-label": u(),
          "aria-controls": e.contentId,
          "aria-expanded": e.open,
          "aria-haspopup": "listbox",
          "data-tgph-combobox-trigger": !0,
          "data-tgph-comobox-trigger-open": e.open,
          disabled: e.disabled,
          children: [
            /* @__PURE__ */ c(Z, {}),
            /* @__PURE__ */ w(I, { align: "center", gap: "1", children: [
              s && /* @__PURE__ */ c(q, { label: "Clear field", children: /* @__PURE__ */ c(
                v,
                {
                  type: "button",
                  icon: { icon: R.X, alt: "Clear field" },
                  size: "1",
                  variant: "ghost",
                  onClick: (o) => {
                    e.value && (o.stopPropagation(), a());
                  },
                  onKeyDown: (o) => {
                    (o.key === "Enter" || o.key === " ") && (o.stopPropagation(), a());
                  },
                  "data-tgph-combobox-clear": !0,
                  style: {
                    // Remove margin to make the clear button flush
                    // with the trigger button
                    marginTop: "calc(-1 * var(--tgph-spacing-1)",
                    marginBottom: "calc(-1 * var(--tgph-spacing-1)"
                  }
                }
              ) }),
              /* @__PURE__ */ c(v.Icon, { icon: R.ChevronDown, "aria-hidden": !0 })
            ] })
          ]
        }
      )
    }
  );
}, te = ({
  tgphRef: t,
  style: l,
  children: e,
  ...u
}) => {
  const s = i.useContext(m), a = i.useRef(!1), o = K(t, s.contentRef), n = i.useRef(null);
  return (
    // We add radix's dismissable layer here so that we can swallow any escape key
    // presses to prevent cases like a modal closing when we close the combobox
    /* @__PURE__ */ c(
      G,
      {
        onEscapeKeyDown: (r) => {
          s.open && (r.stopPropagation(), r.preventDefault(), s.setOpen(!1));
        },
        children: /* @__PURE__ */ c(A, { tgphRef: o, children: /* @__PURE__ */ c(
          D.Content,
          {
            mt: "1",
            onCloseAutoFocus: (r) => {
              var g, h;
              a.current || (h = (g = s.triggerRef) == null ? void 0 : g.current) == null || h.focus(), a.current = !1, r.preventDefault();
            },
            bg: "surface-1",
            style: {
              width: "var(--tgph-comobobox-trigger-width)",
              ...l,
              "--tgph-comobobox-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--tgph-combobox-content-available-width": "var(--radix-popper-available-width)",
              "--tgph-combobox-content-available-height": "calc(var(--radix-popper-available-height) - var(--tgph-spacing-8))",
              "--tgph-comobobox-trigger-width": "var(--radix-popper-anchor-width)",
              "--tgph-combobox-trigger-height": "var(--radix-popper-anchor-height)"
            },
            ...u,
            tgphRef: o,
            "data-tgph-combobox-content": !0,
            "data-tgph-combobox-content-open": s.open,
            role: void 0,
            "aria-orientation": void 0,
            onKeyDown: (r) => {
              var h, b, p, d;
              r.stopPropagation();
              const g = (b = (h = s.contentRef) == null ? void 0 : h.current) == null ? void 0 : b.querySelectorAll(
                "[data-tgph-combobox-option]"
              );
              document.activeElement === (g == null ? void 0 : g[0]) && U.includes(r.key) && ((d = (p = s.searchRef) == null ? void 0 : p.current) == null || d.focus());
            },
            children: /* @__PURE__ */ c(I, { direction: "column", gap: "1", tgphRef: n, children: e })
          }
        ) })
      }
    )
  );
}, oe = ({ ...t }) => {
  const l = i.useContext(m);
  return /* @__PURE__ */ c(
    I,
    {
      id: l.contentId,
      direction: "column",
      gap: "1",
      style: {
        overflowY: "auto",
        // Available Height - Padding from edge of screen
        maxHeight: "calc(var(--tgph-combobox-content-available-height) - var(--tgph-spacing-12))"
      },
      role: "listbox",
      ...t
    }
  );
}, B = ({
  value: t,
  label: l,
  selected: e,
  onSelect: u,
  ...s
}) => {
  const a = i.useContext(m), [o, n] = i.useState(!1), r = a.value, g = (C(r), !a.searchQuery || t.toLowerCase().includes(a.searchQuery.toLowerCase())), h = C(r) ? r.some((p) => (p == null ? void 0 : p.value) === t) : (r == null ? void 0 : r.value) === t, b = (p) => {
    var x, y;
    p.stopPropagation();
    const d = p;
    if (!(d.key && !j.includes(d.key))) {
      if (p.preventDefault(), a.closeOnSelect === !0 && a.setOpen(!1), u)
        return u(p);
      if (k(r)) {
        const f = a.onValueChange;
        f == null || f({ value: t, label: l });
      } else if (C(r)) {
        const f = a.onValueChange, S = h ? r.filter((T) => (T == null ? void 0 : T.value) !== t) : [...r, { value: t, label: l }];
        f == null || f(S);
      }
      (y = (x = a.triggerRef) == null ? void 0 : x.current) == null || y.focus();
    }
  };
  if (g)
    return /* @__PURE__ */ c(
      D.Button,
      {
        type: "button",
        onSelect: b,
        onKeyDown: b,
        selected: e === null ? null : e ?? h,
        onFocus: () => n(!0),
        onBlur: () => n(!1),
        role: "option",
        "aria-selected": h ? "true" : "false",
        "data-tgph-combobox-option": !0,
        "data-tgph-combobox-option-focused": o,
        "data-tgph-combobox-option-value": t,
        "data-tgph-combobox-option-label": l,
        ...s,
        children: l || t
      }
    );
}, re = ({
  label: t = "Search",
  placeholder: l = "Search",
  tgphRef: e,
  value: u,
  onValueChange: s,
  ...a
}) => {
  var b;
  const o = i.useId(), n = i.useContext(m), r = K(e, n.searchRef), g = u ?? n.searchQuery, h = s ?? n.setSearchQuery;
  return i.useEffect(() => {
    var x;
    const p = (y) => {
      var f, S;
      N.includes(y.key) && ((S = (f = n.contentRef) == null ? void 0 : f.current) == null || S.focus({ preventScroll: !0 })), y.key === "Escape" && n.setOpen(!1), y.stopPropagation();
    }, d = (x = n.searchRef) == null ? void 0 : x.current;
    if (d)
      return d.addEventListener("keydown", p), () => {
        d.removeEventListener("keydown", p);
      };
  }, [n]), /* @__PURE__ */ w(A, { borderBottom: "px", px: "1", pb: "1", children: [
    /* @__PURE__ */ c(Y.Root, { children: /* @__PURE__ */ c(L, { as: "label", htmlFor: o, children: t }) }),
    /* @__PURE__ */ c(
      X,
      {
        id: o,
        variant: "ghost",
        placeholder: l,
        value: g,
        onChange: (p) => {
          h(p.target.value);
        },
        LeadingComponent: /* @__PURE__ */ c(F, { icon: R.Search, alt: "Search Icon" }),
        TrailingComponent: n != null && n.searchQuery && ((b = n == null ? void 0 : n.searchQuery) == null ? void 0 : b.length) > 0 ? /* @__PURE__ */ c(
          v,
          {
            variant: "ghost",
            color: "gray",
            icon: { icon: R.X, alt: "Clear Search Query" },
            onClick: () => {
              var p;
              return (p = n.setSearchQuery) == null ? void 0 : p.call(n, "");
            }
          }
        ) : null,
        autoFocus: !0,
        "data-tgph-combobox-search": !0,
        "aria-controls": n.contentId,
        ...a,
        tgphRef: r
      }
    )
  ] });
}, ne = ({
  icon: t = { icon: R.Search, alt: "Search Icon" },
  message: l = "No results found",
  children: e,
  ...u
}) => {
  const s = i.useContext(m), [a, o] = i.useState(!1);
  if (i.useEffect(() => {
    var r, g;
    const n = (g = (r = s.contentRef) == null ? void 0 : r.current) == null ? void 0 : g.querySelectorAll(
      "[data-tgph-combobox-option]"
    );
    (n == null ? void 0 : n.length) === 0 ? o(!0) : o(!1);
  }, [s.searchQuery, s.contentRef, e]), a)
    return /* @__PURE__ */ w(
      I,
      {
        gap: "1",
        align: "center",
        justify: "center",
        w: "full",
        my: "8",
        "data-tgph-combobox-empty": !0,
        ...u,
        children: [
          t === null ? /* @__PURE__ */ c(V, {}) : /* @__PURE__ */ c(F, { ...t }),
          l === null ? /* @__PURE__ */ c(V, {}) : /* @__PURE__ */ c(L, { as: "span", children: l })
        ]
      }
    );
}, ae = ({
  leadingText: t = "Create",
  values: l,
  onCreate: e,
  selected: u = null,
  ...s
}) => {
  const a = i.useContext(m), o = i.useCallback(
    (n) => !l || (l == null ? void 0 : l.length) === 0 ? !1 : l.some((r) => (r == null ? void 0 : r.value) === n),
    [l]
  );
  if (a.searchQuery && !o(a.searchQuery))
    return /* @__PURE__ */ c(
      B,
      {
        leadingIcon: { icon: R.Plus, "aria-hidden": !0 },
        mx: "1",
        value: a.searchQuery,
        label: `${t} "${a.searchQuery}"`,
        selected: u,
        onSelect: () => {
          var n;
          e && a.value && a.searchQuery && (k(a.value) && e({ value: a.searchQuery }), C(a.value) && e({ value: a.searchQuery }), (n = a.setSearchQuery) == null || n.call(a, ""));
        },
        ...s
      }
    );
}, le = {};
Object.assign(le, {
  Root: J,
  Trigger: ee,
  Content: te,
  Options: oe,
  Option: B,
  Search: re,
  Empty: ne,
  Create: ae
});
export {
  le as Combobox
};
//# sourceMappingURL=index.mjs.map
